<script>
import {
    mapGetters
} from 'vuex';
export default {
    name: 'ResourceLinksDataProvider',
    props: {
		processId: {
            type: String,
            default: '0'
		},
		processStepId: {
            type: String,
            default: '0'
		},
		resourceId: {
			type: String,
			default: '0'
		},
	},
	data: () => ({
        showCreate: false,
    }),
	computed: mapGetters('processes', {
		resourceLinks: 'resourceLinks'
	}),
	methods: {
		createResourceLink(resourceLink) {
            this.$store.dispatch('processes/createProcessStepResourceLink', {
				processId: this.processId,
				processStepId: this.processStepId,
				processStepResourceId: this.resourceId,
				text: resourceLink.text,
				link: resourceLink.link,
			}).then(() => {
				this.setShowCreate(false);
			});
		},
		sortResourceLinks( { id, sortIndex }){
            this.$store.dispatch('processes/sortProcessStepResourceLink', {
				processId: this.processId,
				id: id,
				processStepId: this.processStepId,
				resourceId: this.resourceId,
                sortIndex: sortIndex,
            });
		},
		editResourceLink({resourceLinkId, text, link}){
			this.$store.dispatch('processes/editProcessStepResourceLink', {
				processId: this.processId,
				processStepId: this.processStepId,
				resourceId: this.resourceId,
                resourceLinkId: resourceLinkId,
				text: text,
				link: link,
            });
		},
		deleteResourceLink(resourceLinkId) {
			this.$store.dispatch('processes/deleteProcessStepResourceLink', {
				processId: this.processId,
				processStepId: this.processStepId,
				resourceId: this.resourceId,
				resourceLinkId: resourceLinkId,
			});
		},
		setShowCreate(value) {
			this.showCreate = value;
		}
	},
	render () {
		if (!this.$scopedSlots.default) {
			return;
		}
	
		const slotScope = {
			resourceLinks: this.resourceLinks(this.processId, this.processStepId, this.resourceId),
			createResourceLink: this.createResourceLink,
			editResourceLink: this.editResourceLink,
			deleteResourceLink: this.deleteResourceLink,
			sortResourceLinks: this.sortResourceLinks,
			showCreate: this.showCreate,
			setShowCreate: this.setShowCreate,
		};
				
		return this.$scopedSlots.default(slotScope);
	},
}
</script>